import { BasketFactory } from "../../../factories/manhattan/basket/BasketFactory";
import { IBasketOrderItems } from "../../manhattan/order/types";
import { ITransactionDetailsFtth, ITransactionDetailsOtt, ITransactionDetailsTelco, ITransactionWithBasketItems } from "./types";

export default class Transaction implements ITransactionWithBasketItems {

  flow: string;
  details: ITransactionDetailsFtth |  ITransactionDetailsOtt | ITransactionDetailsTelco;
  basket: IBasketOrderItems[];
  onlyPosition: boolean;


  constructor(flow: string, details: ITransactionDetailsOtt | ITransactionDetailsFtth | ITransactionDetailsTelco, basket: IBasketOrderItems[], onlyPosition: boolean) {
    this.flow = flow;
    this.details = details;
    this.basket = BasketFactory.create(basket);
    this.onlyPosition = onlyPosition;
  }

}
